<template>
  <div class="sot">
    <youtube
      :video-id="sot.vidoeId"
      :player-width="videoWidth"
      :player-height="videoWidth * 0.5625"
    ></youtube>
    <div class="sot__content">
      <div
        v-for="(title, i) in sot.title"
        :key="i"
        class="sot__content--title mobile"
        v-html="title"
      />
      <span
        v-for="(title, i) in sot.title"
        :key="i"
        class="sot__content--title desktop"
        v-html="title"
      />
      <div class="sot__content--desc">{{ sot.desc }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sot",
  props: {
    sot: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },

  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  computed: {
    videoWidth() {
      let desktopWidth;
      if (this.windowWidth > 768) {
        desktopWidth =
          this.windowWidth - 344 - 79 * 2 > 983
            ? 983
            : this.windowWidth - 344 - 79 * 2;
        return desktopWidth * 0.8;
      }
      return this.windowWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
.sot {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  max-width: 983px;
  margin: 0 auto;
  @media (min-width: 768px) {
    padding: 24px 0;
    overflow: hidden;
    min-height: calc(100vh - 233px);
  }

  &__content {
    padding: 28px 56px;
    @media (min-width: 768px) {
      padding: 15px 74px;
    }
    @media (min-width: 1400px) {
      padding: 15px 0px;
    }
    &--title {
      font-weight: 700;
      font-size: 20px;
      line-height: 30px;
      text-align: center;
      color: #009944;
      @media (min-width: 768px) {
        font-size: 42px;
        line-height: 60px;
      }
    }
    &--desc {
      margin-top: 28px;
      font-weight: 350;
      font-size: 16px;
      line-height: 24px;
      color: #009944;
      @media (min-width: 768px) {
        font-size: 20px;
        line-height: 29px;
        margin-top: 16px;
      }
    }
  }
}

.desktop {
  display: none;
  @media (min-width: 768px) {
    display: inline;
  }
}
</style>
